import Profile from '../components/Profile'
import withAuth from '../components/auth'

const ProfilePage = ({ auth }) => <Profile auth={auth} />

export default withAuth(ProfilePage)
